import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CclNavbarSecondaryService, CclDrawerService } from "certain-common-library";

@Component({
    selector: "app-setting-page",
    templateUrl: "./setting-page.view.html",
    styleUrls: []
})
export class SettingPageView implements AfterViewInit, OnInit {
    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        private drawerService: CclDrawerService,
        private router: Router
    ) {
        this.navSecondaryService.sectionLabel = "Define Layout";
    }

    ngAfterViewInit(): void {}

    ngOnInit() {
        this.navSecondaryService.sectionLabel = "Define Layout";
    }
}
